import React, { useState, useEffect, useGlobal } from 'reactn';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// import Lightbox from 'react-image-lightbox';
// import '../lightbox.css'
// import { GatsbyImage } from "gatsby-plugin-image"
import { Box, Button, Image, Spinner, VStack, shouldForwardProp } from '@chakra-ui/react';
import { ArrowLeftIcon, ArrowRightIcon } from '@chakra-ui/icons';
// import Video from '../video';
import { ZoomImage } from '../imgZoom';

import { chakra } from '@chakra-ui/react';
import { motion, isValidMotionProp } from 'framer-motion';
import './aiSlider.css'

const ChakraBox = chakra(motion.div, {
    /**
     * Allow motion props and non-Chakra props to be forwarded.
     */
    shouldForwardProp: (prop) => isValidMotionProp(prop) || shouldForwardProp(prop),
});


const AIIngSlider = ({ links, selected, title, fetchingScarf = false, fetching = false, isDesign = false, onClickEvent }) => {
    const [slider1, setSlider1] = useState(null);
    const [linkCount, setLinkCount] = useState(links ? links.length : 0)
    const [slideToShow, setSlideToShow] = useState(0)
    console.log("IMAGES", links)
    useEffect(() => {
        slider1 && slider1.slickGoTo(0)
    }, [links]);



    // console.log("IMG SLIDER", images)
    // console.log("IMG SLIDER X", design, scarves)    
    // console.log("IMAGE DATA", imgData)
    const settingsMain = {
        dots: false,
        fade: false,
        initialSlide: slideToShow,
        infinite: true,
        speed: 650,
        autoplaySpeed: 3000,
        fadeIn: false,
        // marginLeft: '20px',
        // marginRight: 200,
        autoplay: false,
        pauseOnHover: true,
        // asNavFor: '.slider-nav',
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        // lazyLoad: 'progressive',
        nextArrow: (
            <ArrowRightIcon w={4} h={4} color="grey !important" />
        ),
        prevArrow: (
            <ArrowLeftIcon w={4} h={4} color="grey !important" />
        ),
        responsive: [
            {
                breakpoint: 8000,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true
                },
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: true,
                },
            },
        ],
    };

    // function handleMoveNextRequest(e) {
    //     e && e.preventDefault();
    //     setPhotoIndex((photoIndex + 1) % images.length)
    // }

    // function handleMovePrevRequest(e) {
    //     e && e.preventDefault();
    //     setPhotoIndex((photoIndex + images.length - 1) % images.length)
    // }

    // function handleCloseModal(e) {
    //     e && e.preventDefault();
    //     setIsOpen(false)

    // }

    // function handleClickImage(e, index) {
    //     e && e.preventDefault();
    //     setPhotoIndex(index)
    //     setIsOpen(true)
    // }
    // console.log("imgData", imgData)

    return (
        <Box
            // display={'flex'}
            marginLeft={[0, 0, 10, 10]}
            marginRight={[0, 0, 10, 10]}
            marginBottom={10}
            className="slider-wrapper "
        >
            {links &&
                <>
                    <Slider {...settingsMain}
                        initialSlide={0}
                        className='aiSlider'
                        // asNavFor={nav1}
                        ref={slider => (setSlider1(slider))}
                    >

                        {links.map((link, index) => {
                            const istSelected = link.guid == selected
                            return (

                                <Box key={`img${index}`} 
                                paddingTop={5}
                                paddingRight={5}
                                paddingLeft={[5,5,10,10]}
                                    >
                                    <VStack>
                                        <ZoomImage
                                            className="carouselImage aiSlider"
                                            // paddingLeft={'10px'}
                                            // paddingRight={'10px'}
                                            fallbackSrc='https://via.placeholder.com/200x200'
                                            objectFit={'cover'}
                                            // loading={index <= 2 ? "eager" : "lazy"}
                                            alt={link.prompt}
                                            width={'200px'}
                                            height={'200px'}
                                            src={link ? link.link : null}
                                        />
                                        <Box>
                                            <Button variant={istSelected ? 'aidesignSelected' : 'aidesign'}
                                                isActive={istSelected}
                                                isDisabled={fetching || fetchingScarf}
                                                onClick={() => onClickEvent(link)}
                                            // rightIcon={fetching && istSelected ?                                             
                                            // <Spinner size='xs' />
                                            //  : null}
                                            >{istSelected ? fetching && istSelected ? "GENERATING" : 'SELECTED' : 'SELECT'} </Button>
                                        </Box>
                                    </VStack>
                                </Box>




                            )
                        })
                        }
                    </Slider>

                </>
            }
        </Box>
    )

}

export default AIIngSlider